import { makeRe } from 'micromatch';

const globToRegEx = (str: string): RegExp =>
  new RegExp(
    `^${makeRe(str, { contains: true }).source}(?:/(?:$|#|\\?)|\\?|#|$)`,
  );

const filterRoutes = new Map(
  [
    '/login',
    '/logout',
    '/**/login',
    '/register',
    '/passwordreset',
    '/passwordreset/?*',
    '/static/*',
    '/static/**/*',
    // public/ of the theme: icons and manifest for the login page (#22836)
    '/favicon.ico',
    '/favicon-16x16.png',
    '/favicon-32x32.png',
    '/apple-touch-icon.png',
    '/android-chrome-192x192.png',
    '/android-chrome-512x512.png',
    '/icon.svg',
    '/site.webmanifest',
  ].map((str) => [str, globToRegEx(str)]),
);

export default filterRoutes;
